import Vue from 'vue'
// import VueApexCharts from 'vue-apexcharts'
// Vue.use(VueApexCharts)

// Lazy: apexcharts is only downloaded when a page first renders <apexchart> (dashboards),
// instead of being in chunk-vendors on every page. Nothing uses $apexcharts / window.ApexCharts.
Vue.component('apexchart', () => import('vue-apexcharts'))
